module.exports = __webpack_public_path__ + "static/IBMPlexMono-Italic-d89650fb7706d85c016e092e05128f2c.woff2";